module.exports = __webpack_public_path__ + "static/media/image-card-7.1f0772b7.png";